{
 "version": 1,
 "categories": [
  {
   "id": "ai",
   "name": "AI",
   "kind": "topic",
   "subcategories": [
    {
     "id": "ai-models-and-labs",
     "name": "AI Models & Labs",
     "hint": "frontier models, model releases, OpenAI, Anthropic, Google DeepMind"
    },
    {
     "id": "ai-agents",
     "name": "AI Agents",
     "hint": "autonomous agents, tool use, multi-agent systems"
    },
    {
     "id": "ai-coding",
     "name": "AI Coding",
     "hint": "AI-assisted programming, coding agents"
    },
    {
     "id": "ai-safety-and-alignment",
     "name": "AI Safety & Alignment"
    },
    {
     "id": "ai-policy-and-regulation",
     "name": "AI Policy & Regulation"
    },
    {
     "id": "ai-and-jobs",
     "name": "AI & Jobs",
     "hint": "effects of AI on work and employment"
    },
    {
     "id": "ai-research",
     "name": "AI Research",
     "hint": "ML papers, methods, training"
    },
    {
     "id": "ai-products-and-startups",
     "name": "AI Products & Startups",
     "hint": "companies and products built on AI"
    },
    {
     "id": "ai-chips-and-compute",
     "name": "AI Chips & Compute",
     "hint": "GPUs, Nvidia, data centers, compute supply"
    },
    {
     "id": "evals-and-benchmarks",
     "name": "Evals & Benchmarks"
    },
    {
     "id": "prompting",
     "name": "Prompting",
     "hint": "prompt and context engineering"
    },
    {
     "id": "open-source-ai",
     "name": "Open-Source AI",
     "hint": "open-weight models"
    },
    {
     "id": "ai-forecasting",
     "name": "AI Forecasting",
     "hint": "timelines, takeoff, intelligence explosion"
    },
    {
     "id": "ai-consciousness-and-minds",
     "name": "AI Consciousness & Minds",
     "hint": "machine consciousness, AI minds and moral status"
    },
    {
     "id": "ai-and-creativity",
     "name": "AI & Creativity",
     "hint": "AI art, writing, music"
    },
    {
     "id": "robotics",
     "name": "Robotics"
    },
    {
     "id": "jev-and-typesafe",
     "name": "Jev & TypeSafe",
     "hint": "TypeSafe's Jev model"
    }
   ]
  },
  {
   "id": "tech",
   "name": "Tech",
   "kind": "topic",
   "subcategories": [
    {
     "id": "software-engineering",
     "name": "Software Engineering"
    },
    {
     "id": "developer-tools",
     "name": "Developer Tools"
    },
    {
     "id": "programming-languages",
     "name": "Programming Languages"
    },
    {
     "id": "cloud-and-infrastructure",
     "name": "Cloud & Infrastructure"
    },
    {
     "id": "security-and-privacy",
     "name": "Security & Privacy"
    },
    {
     "id": "mobile-apps",
     "name": "Mobile Apps"
    },
    {
     "id": "the-web",
     "name": "The Web",
     "hint": "browsers, websites, web standards"
    },
    {
     "id": "design-and-ux",
     "name": "Design & UX"
    },
    {
     "id": "big-tech",
     "name": "Big Tech",
     "hint": "Apple, Google, Meta, Microsoft, Amazon as companies"
    },
    {
     "id": "social-media",
     "name": "Social Media"
    },
    {
     "id": "crypto",
     "name": "Crypto"
    },
    {
     "id": "hardware-and-gadgets",
     "name": "Hardware & Gadgets"
    }
   ]
  },
  {
   "id": "business",
   "name": "Business",
   "kind": "topic",
   "subcategories": [
    {
     "id": "startups",
     "name": "Startups"
    },
    {
     "id": "bootstrapping-and-indie-hacking",
     "name": "Bootstrapping & Indie Hacking",
     "hint": "small self-funded businesses, solo founders"
    },
    {
     "id": "saas",
     "name": "SaaS",
     "hint": "software-as-a-service businesses"
    },
    {
     "id": "venture-capital",
     "name": "Venture Capital"
    },
    {
     "id": "marketing-and-growth",
     "name": "Marketing & Growth"
    },
    {
     "id": "sales",
     "name": "Sales"
    },
    {
     "id": "pricing",
     "name": "Pricing"
    },
    {
     "id": "management-and-leadership",
     "name": "Management & Leadership"
    },
    {
     "id": "hiring-and-careers",
     "name": "Hiring & Careers"
    },
    {
     "id": "remote-work",
     "name": "Remote Work"
    },
    {
     "id": "creator-economy",
     "name": "Creator Economy"
    },
    {
     "id": "legal-and-business-setup",
     "name": "Legal & Business Setup",
     "hint": "LLCs, incorporation, contracts, business taxes"
    },
    {
     "id": "personal-finance",
     "name": "Personal Finance"
    },
    {
     "id": "investing-and-markets",
     "name": "Investing & Markets"
    },
    {
     "id": "company-profiles",
     "name": "Company Profiles",
     "hint": "the story or strategy of one company"
    }
   ]
  },
  {
   "id": "economics",
   "name": "Economics",
   "kind": "topic",
   "subcategories": [
    {
     "id": "macroeconomics",
     "name": "Macroeconomics"
    },
    {
     "id": "labor-market",
     "name": "Labor Market"
    },
    {
     "id": "inflation-and-interest-rates",
     "name": "Inflation & Interest Rates"
    },
    {
     "id": "trade-and-tariffs",
     "name": "Trade & Tariffs"
    },
    {
     "id": "housing",
     "name": "Housing"
    },
    {
     "id": "energy",
     "name": "Energy"
    },
    {
     "id": "growth-and-productivity",
     "name": "Growth & Productivity"
    },
    {
     "id": "inequality",
     "name": "Inequality"
    },
    {
     "id": "economic-data",
     "name": "Economic Data",
     "hint": "GDP, statistics, charts of the economy"
    }
   ]
  },
  {
   "id": "politics-and-policy",
   "name": "Politics & Policy",
   "kind": "topic",
   "subcategories": [
    {
     "id": "us-politics",
     "name": "US Politics"
    },
    {
     "id": "elections",
     "name": "Elections"
    },
    {
     "id": "government-and-policy",
     "name": "Government & Policy"
    },
    {
     "id": "education-policy",
     "name": "Education Policy"
    },
    {
     "id": "health-policy",
     "name": "Health Policy"
    },
    {
     "id": "immigration",
     "name": "Immigration"
    },
    {
     "id": "law-and-courts",
     "name": "Law & Courts"
    },
    {
     "id": "geopolitics",
     "name": "Geopolitics"
    },
    {
     "id": "china",
     "name": "China"
    },
    {
     "id": "climate-policy",
     "name": "Climate Policy"
    },
    {
     "id": "political-philosophy",
     "name": "Political Philosophy"
    }
   ]
  },
  {
   "id": "science-and-health",
   "name": "Science & Health",
   "kind": "topic",
   "subcategories": [
    {
     "id": "medicine",
     "name": "Medicine"
    },
    {
     "id": "biology",
     "name": "Biology"
    },
    {
     "id": "neuroscience",
     "name": "Neuroscience"
    },
    {
     "id": "physics",
     "name": "Physics"
    },
    {
     "id": "space",
     "name": "Space"
    },
    {
     "id": "climate-science",
     "name": "Climate Science"
    },
    {
     "id": "nutrition",
     "name": "Nutrition"
    },
    {
     "id": "fitness-and-training",
     "name": "Fitness & Training"
    },
    {
     "id": "running",
     "name": "Running"
    },
    {
     "id": "mental-health",
     "name": "Mental Health"
    },
    {
     "id": "longevity",
     "name": "Longevity"
    }
   ]
  },
  {
   "id": "society-and-culture",
   "name": "Society & Culture",
   "kind": "topic",
   "subcategories": [
    {
     "id": "education",
     "name": "Education",
     "hint": "learning and education in general"
    },
    {
     "id": "schools-and-teaching",
     "name": "Schools & Teaching",
     "hint": "K-12 schools, teachers, classrooms"
    },
    {
     "id": "media-and-journalism",
     "name": "Media & Journalism"
    },
    {
     "id": "culture-wars",
     "name": "Culture Wars"
    },
    {
     "id": "religion",
     "name": "Religion"
    },
    {
     "id": "history",
     "name": "History"
    },
    {
     "id": "books-and-literature",
     "name": "Books & Literature"
    },
    {
     "id": "film-and-tv",
     "name": "Film & TV"
    },
    {
     "id": "music",
     "name": "Music"
    },
    {
     "id": "sports",
     "name": "Sports"
    },
    {
     "id": "travel",
     "name": "Travel"
    },
    {
     "id": "hiking-and-outdoors",
     "name": "Hiking & Outdoors"
    }
   ]
  },
  {
   "id": "ideas",
   "name": "Ideas",
   "kind": "topic",
   "subcategories": [
    {
     "id": "philosophy",
     "name": "Philosophy"
    },
    {
     "id": "ethics",
     "name": "Ethics"
    },
    {
     "id": "rationality-and-decision-making",
     "name": "Rationality & Decision-Making"
    },
    {
     "id": "psychology",
     "name": "Psychology"
    },
    {
     "id": "learning-and-expertise",
     "name": "Learning & Expertise",
     "hint": "how people get good at things"
    },
    {
     "id": "productivity",
     "name": "Productivity"
    },
    {
     "id": "writing-and-craft",
     "name": "Writing & Craft"
    },
    {
     "id": "life-advice",
     "name": "Life Advice"
    },
    {
     "id": "parenting-and-family",
     "name": "Parenting & Family"
    },
    {
     "id": "futurism",
     "name": "Futurism"
    }
   ]
  },
  {
   "id": "format",
   "name": "Format",
   "kind": "format",
   "subcategories": [
    {
     "id": "essay",
     "name": "Essay",
     "hint": "a long-form argument or reflection"
    },
    {
     "id": "news",
     "name": "News",
     "hint": "reporting on recent events"
    },
    {
     "id": "opinion",
     "name": "Opinion",
     "hint": "a short argued take or column"
    },
    {
     "id": "interview-and-podcast-notes",
     "name": "Interview & Podcast Notes",
     "hint": "a conversation, interview or podcast summary"
    },
    {
     "id": "tutorial-and-how-to",
     "name": "Tutorial & How-To",
     "hint": "step-by-step instructions"
    },
    {
     "id": "research-and-data",
     "name": "Research & Data",
     "hint": "a study, report or data analysis"
    },
    {
     "id": "roundup-and-link-post",
     "name": "Roundup & Link Post",
     "hint": "a digest of many links or items"
    },
    {
     "id": "social-post-thread",
     "name": "Social Post / Thread",
     "hint": "a social media post or thread"
    },
    {
     "id": "review",
     "name": "Review",
     "hint": "a review of a product, book, film or work"
    },
    {
     "id": "fiction",
     "name": "Fiction",
     "hint": "a story or creative writing"
    }
   ]
  },
  {
   "id": "source",
   "name": "Source",
   "kind": "source",
   "subcategories": [
    {
     "id": "substack",
     "name": "Substack"
    },
    {
     "id": "x-twitter",
     "name": "X / Twitter"
    },
    {
     "id": "newspaper",
     "name": "Newspaper"
    },
    {
     "id": "magazine",
     "name": "Magazine"
    },
    {
     "id": "academic",
     "name": "Academic"
    },
    {
     "id": "government",
     "name": "Government"
    },
    {
     "id": "video",
     "name": "Video"
    },
    {
     "id": "web",
     "name": "Web"
    }
   ]
  }
 ]
}
